<script>
export default {

  name: 'pricingstatus',


  props: [
    'context',
  ],

  data: function(){
    return {
    };
  },

  computed: {

    paddlePaidTroughInPast: function(){
      if (!this.$store.state.user.paddle_sub_paid_through) return false;
      return new Date(this.$store.state.user.paddle_sub_paid_through) < new Date();
    },

    braintreePaidThroughInPast: function(){
      if (!this.$store.state.user.premium_paid_through) return false;
      return new Date(this.$store.state.user.premium_paid_through) < new Date();
    },


    subNoRenewal: function(){
      if (this.paddlePaidTroughInPast) return false;
      if (this.$store.state.user.paddle_sub_status==='deleted') return true;
      if (this.$store.state.user.premium_paid_through && !this.$store.state.user.paddle_sub_paid_through) return true;
      return false;
    },

    subPastDue: function(){
      return this.$store.state.user.paddle_sub_status==='past_due';
    },


    showActiveStatus: function(){
      //var paddlePud = this.$store.state.user.paddle_sub_paid_through;
      //var braintreePud = this.$store.state.user.premium_paid_through;
      //var mgmtPud = this.$store.state.user.mgmt_premium_until;
      //if (!paddlePud || !braintreePud) return false;

      if (!this.$store.state.user.is_premium) return false;
      if (!this.paddlePaidTroughInPast || !this.braintreePaidThroughInPast) return true;
      return false;
    },


    showPreviousSubNotif: function(){
      if (this.$store.state.user.paddle_sub_paid_through) return false;
      if (this.braintreePaidThroughInPast) return false;
      return true;
    },

    subPaidThrough: function(){
      if (this.$store.state.user.paddle_sub_paid_through) return this.$store.state.user.paddle_sub_paid_through;
      else if (this.$store.state.user.premium_paid_through) return this.$store.state.user.premium_paid_through;
      else return null;
    },

    readableSubPaidThrough: function(){
      if (!this.subPaidThrough) return '---error---';
      return this.$dfFormatD(this.subPaidThrough);
    },

  },

  created: function(){
  },

  mounted: function(){
  },


  beforeDestroy: function(){
  },



  methods: {


    previousCustomerNotificationClick: function(){
      if (this.context==='settings') {
        this.$router.push('/upgrade');
        return;
      }
      document.querySelector('#upgrade-account').scrollIntoView({behavior: 'smooth'});
    },

  },


};
</script>


<template>
<div class="pricingstatus" :class="['mod-context-'+context]">
  <div class="pricingstatus-content">


    <!--
    <p>user.is_premium: {{$store.state.user.is_premium}} </p>
    <p>user.premium_paid_through: {{}} </p>
    <p>user.paddle_sub_paid_through: {{}} </p>
     -->


    <router-link :to="context==='settings' ? '/upgrade' : '/settings/billing'" class="pricingstatus-section">
      <div class="pricingstatus-image"><img :src="$store.state.user.profile_image" /></div>
      <div class="pricingstatus-text">


        <h3 class="pricingstatus-title" v-if="$store.state.user.paddle_sub_status==='past_due'" key="title1subpastdue">
          Your GGather Plus subscription is <span class="pricingstatus-status-circle mod-red"></span> <strong>past due</strong>.
        </h3>

        <h3 class="pricingstatus-title" v-else-if="paddlePaidTroughInPast" key="title1subpastpaidthrough">
          Your GGather Plus subscription has <strong>expired</strong>.
        </h3>

        <h3 class="pricingstatus-title" v-else-if="showActiveStatus" key="title1subactive">
          Your GGather Plus is <span class="pricingstatus-status"><span class="pricingstatus-status-circle mod-green"></span> <strong>active</strong></span> and paid until {{readableSubPaidThrough}}.
        </h3>

        <h3 class="pricingstatus-title" v-else key="title1upgradetoggplus">
          Upgrade to GGather Plus
        </h3>

        <p class="pricingstatus-subtitle1" v-if="subPastDue" key="subpastdue">
          Please update your payment information to continue your subscription.
        </p>

        <p class="pricingstatus-subtitle1" v-if="showActiveStatus && subNoRenewal" key="title2subdeleted">
          Automatic renewal canceled. Account will be downgraded on subscription end date.
        </p>

        <p class="pricingstatus-subtitle2" v-if="context!=='settings'">Click/tap to manage your billing and subscription data.</p>

      </div>
    </router-link>


    <button v-if="showPreviousSubNotif" key="previousCustomerNotifEl" type="button" class="pricingstatus-notif" @click.prevent="previousCustomerNotificationClick">

      <div class="pricingstatus-notif-header">

        <div class="pricingstatus-notif-header-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24px" height="24px">
            <path d="M 12 3.0292969 C 11.436813 3.0292969 10.873869 3.2917399 10.558594 3.8164062 L 1.7617188 18.451172 C 1.1134854 19.529186 1.94287 21 3.2011719 21 L 20.796875 21 C 22.054805 21 22.886515 19.529186 22.238281 18.451172 L 13.441406 3.8164062 C 13.126131 3.29174 12.563187 3.0292969 12 3.0292969 z M 12 5.2988281 L 20.236328 19 L 3.7636719 19 L 12 5.2988281 z M 11 9 L 11 14 L 13 14 L 13 9 L 11 9 z M 11 16 L 11 18 L 13 18 L 13 16 L 11 16 z" />
          </svg>
        </div>

        <h3 class="pricingstatus-notif-header-title">Due to change in GGather payments processor there are a couple of things you should know as a previous GGather Pro subscriber...</h3>
      </div>
      <ul class="pricingstatus-notif-content">
        <li>
          <strong>• GGather Pro was renamed to GGather Plus. </strong>Only name was changed. Prices and features remain the same.
        </li>
        <li>
          <strong>• All previous GGather Pro subscriptions were cancelled for all users. </strong> This basically means that your subscription won’t automatically renew on its end date.
        </li>
        <li>
          <strong>• You can re-enable automatic renewal by resubscribing to GGather Plus <span v-if="context==='upgrade'"> in section below</span><span v-if="context==='settings'"> by clicking this box</span>. </strong> If you decide to do that you’ll get 1 extra month for free
          <span class="pricingstatus-notif-emoji">
            <svg viewBox="0 0 47.5 47.5" style="enable-background:new 0 0 47.5 47.5;" xml:space="preserve" version="1.1" id="svg2"><metadata id="metadata8"><rdf:RDF><cc:Work rdf:about=""><dc:format>image/svg+xml</dc:format><dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage"/></cc:Work></rdf:RDF></metadata><defs id="defs6"><clipPath id="clipPath16" clipPathUnits="userSpaceOnUse"><path id="path18" d="M 0,38 38,38 38,0 0,0 0,38 Z"/></clipPath></defs><g transform="matrix(1.25,0,0,-1.25,0,47.5)" id="g10"><g id="g12"><g clip-path="url(#clipPath16)" id="g14"><g transform="translate(36,19)" id="g20"><path id="path22" style="fill:#ffcc4d;fill-opacity:1;fill-rule:nonzero;stroke:#b1721e;stroke-width:2px;" d="m 0,0 c 0,-9.389 -7.611,-17 -17,-17 -9.389,0 -17,7.611 -17,17 0,9.389 7.611,17 17,17 C -7.611,17 0,9.389 0,0"/></g><g transform="translate(13,16)" id="g24"><path id="path26" style="fill:#ff7892;fill-opacity:1;fill-rule:nonzero;stroke:none" d="m 0,0 c 0,-2.762 -2.239,-5 -5,-5 -2.761,0 -5,2.238 -5,5 0,2.762 2.239,5 5,5 2.761,0 5,-2.238 5,-5"/></g><g transform="translate(35,16)" id="g28"><path id="path30" style="fill:#ff7892;fill-opacity:1;fill-rule:nonzero;stroke:none" d="m 0,0 c 0,-2.762 -2.238,-5 -5,-5 -2.762,0 -5,2.238 -5,5 0,2.762 2.238,5 5,5 2.762,0 5,-2.238 5,-5"/></g><g transform="translate(29.416,19.2773)" id="g32"><path id="path34" style="fill:#664500;fill-opacity:1;fill-rule:nonzero;stroke:none" d="m 0,0 c -0.061,0.091 -1.515,2.223 -4.416,2.223 -2.9,0 -4.355,-2.132 -4.416,-2.223 -0.135,-0.202 -0.104,-0.47 0.071,-0.638 0.174,-0.167 0.447,-0.184 0.643,-0.041 0.012,0.009 1.262,0.902 3.702,0.902 2.426,0 3.674,-0.882 3.702,-0.902 0.089,-0.066 0.194,-0.098 0.298,-0.098 0.124,0 0.248,0.046 0.344,0.136 C 0.105,-0.473 0.135,-0.203 0,0"/></g><g transform="translate(13,21.5)" id="g36"><path id="path38" style="fill:#664500;fill-opacity:1;fill-rule:nonzero;stroke:none" d="M 0,0 C -2.9,0 -4.355,-2.132 -4.416,-2.223 -4.55,-2.424 -4.52,-2.692 -4.345,-2.86 -4.169,-3.027 -3.898,-3.045 -3.703,-2.902 -3.69,-2.893 -2.441,-2 0,-2 2.426,-2 3.674,-2.881 3.702,-2.901 3.791,-2.967 3.896,-3 4,-3 c 0.124,0 0.248,0.046 0.344,0.137 0.177,0.167 0.207,0.438 0.072,0.64 C 4.355,-2.132 2.901,0 0,0"/></g><g transform="translate(22.8711,10)" id="g40"><path id="path42" style="fill:#664500;fill-opacity:1;fill-rule:nonzero;stroke:none" d="m 0,0 c 1.335,0.412 2.629,1.156 2.629,2.5 0,2.619 -4.912,2.968 -5.473,2.999 C -3.121,5.535 -3.354,5.305 -3.37,5.031 -3.387,4.758 -3.18,4.521 -2.906,4.501 -2.871,4.499 0.629,4.202 0.629,2.5 0.629,0.798 -2.871,0.501 -2.906,0.499 -2.916,0.498 -2.923,0.493 -2.933,0.492 -3.057,0.484 -3.163,0.427 -3.242,0.333 -3.247,0.327 -3.251,0.319 -3.257,0.312 -3.286,0.273 -3.311,0.234 -3.33,0.187 -3.341,0.16 -3.346,0.131 -3.352,0.102 -3.356,0.078 -3.368,0.056 -3.37,0.031 -3.371,0.021 -3.366,0.011 -3.366,0 c 0,-0.011 -0.005,-0.021 -0.004,-0.031 0.002,-0.026 0.013,-0.046 0.018,-0.071 0.006,-0.029 0.011,-0.058 0.023,-0.086 0.013,-0.033 0.032,-0.06 0.051,-0.088 0.016,-0.024 0.03,-0.047 0.049,-0.068 0.024,-0.024 0.052,-0.043 0.082,-0.062 0.023,-0.017 0.045,-0.033 0.071,-0.046 0.031,-0.015 0.065,-0.021 0.1,-0.027 0.024,-0.006 0.044,-0.018 0.07,-0.02 0.035,-0.002 3.535,-0.299 3.535,-2.001 0,-1.702 -3.5,-1.999 -3.535,-2.001 -0.274,-0.02 -0.481,-0.257 -0.464,-0.53 0.016,-0.265 0.236,-0.469 0.499,-0.469 0.009,0 0.019,0 0.027,0.001 0.561,0.031 5.473,0.38 5.473,2.999 0,1.344 -1.294,2.088 -2.629,2.5"/></g><g transform="translate(32.001,21)" id="g44"><path id="path46" style="fill:#664500;fill-opacity:1;fill-rule:nonzero;stroke:none" d="M 0,0 C -0.305,0 -0.605,0.138 -0.801,0.4 -3.441,3.921 -6.862,3.999 -7.007,4 -7.557,4.006 -8.001,4.456 -7.998,5.005 -7.995,5.556 -7.551,6 -7.001,6 -6.817,6 -2.464,5.95 0.799,1.6 1.131,1.158 1.041,0.531 0.599,0.2 0.419,0.065 0.209,0 0,0"/></g><g transform="translate(5.999,21)" id="g48"><path id="path50" style="fill:#664500;fill-opacity:1;fill-rule:nonzero;stroke:none" d="m 0,0 c -0.208,0 -0.419,0.065 -0.599,0.2 -0.442,0.331 -0.531,0.958 -0.2,1.4 3.262,4.35 7.616,4.4 7.8,4.4 0.552,0 1,-0.448 1,-1 C 8.001,4.449 7.556,4.002 7.005,4 6.85,3.998 3.437,3.914 0.801,0.4 0.604,0.138 0.304,0 0,0"/></g></g></g></g></svg>
          </span>.
        </li>
      </ul>

    </button>


  </div>
</div>
</template>


<style lang="scss" scoped>
  @import "../../../common/style/_variables.scss";

  .pricingstatus {
    background: #F6F6F6;
    max-width: 640px;
    width: 100%;
    border-radius: 8px;
    //box-shadow: 0 2px 10px 0px rgba(black,.13);
    border: 1px solid darken(white,12);
    margin-bottom: 20px;
    padding: 20px;

    &.mod-context-settings {
      margin-left: 0px;
      margin-right: 0px;
      margin-bottom: 0;
      max-width: none;
      width: 100%;
      border-radius: 4px;
      background: darken(white,5);
      box-shadow: none;
      padding: 15px;

    }


    @media (max-width: 670px) {
      margin-left: auto;
      margin-right: auto;
      width: 100%;
      margin-bottom: 5px;
      padding: 10px;
      &.mod-context-settings {

      }
    }


  }



    .pricingstatus-content {
      text-align: left;
    }




      .pricingstatus-section {
        display: flex;
        justify-content: flex;
        align-items: center;
        align-content: center;
        text-align: left;
        padding: 5px;




        position: relative;

        &::before {
          transition: opacity 100ms ease-in-out;
          content: '';
          position: absolute;
          z-index: 1;
          top:    0px;
          left:   0px;
          right:  0px;
          bottom: 0px;
          border-radius: 4px;
          background: rgba($clr-ggather, 0.08);
          background: darken(white,8);
          opacity: 0;
          pointer-events: none;

        }
        &:hover::before {
          opacity: 1;
        }

        .pricingstatus.mod-context-settings {

        }
        .pricingstatus.mod-context-settings &:hover::before {
          opacity: 0;
        }


        @media (max-width: 670px) {
          align-items: flex-start;
        }
      }


        .pricingstatus-image {
          position: relative;
          z-index: 3;
          img {
            width: 60px;
            height: 60px;
            overflow: hidden;
            border-radius: 500px;
            background-color: #eee;
            border: 1px solid darken(white, 15);
            box-shadow: 0 1px 10px 0 rgba(black,.15);
          }
          @media (max-width: 670px) {
            img {
              width: 40px;
              height: 40px;
            }
          }

        }

        .pricingstatus-text {
          padding-left: 18px;
          position: relative;
          z-index: 3;
          @media (max-width: 670px) {
            padding-left: 10px;
          }
        }

          .pricingstatus-title {
            font-size: 16px;
            font-weight: 600;
            line-height: 1.2;
            color: darken(white,90);

            strong {
              font-weight: 700;
              color: darken(white,100);
            }
            @media (max-width: 670px) {
              font-size: 15px;
            }
          }

          .pricingstatus-subtitle1 {
            font-size: 12px;
            font-weight: 500;
            line-height: 1.2;
            color: darken(white,80);
            margin-top: 7px;
          }

          .pricingstatus-subtitle2 {
            font-size: 11px;
            font-weight: 400;
            line-height: 1.2;
            color: darken(white,70);
            margin-top: 7px;
          }

          .pricingstatus-status {
            white-space: nowrap;
          }

          .pricingstatus-status-circle {
            width: 12px;
            height: 12px;
            border-radius: 50px;
            background: black;
            display: inline-block;
            vertical-align: baseline;
            margin-left: 4px;
            margin-right: 1px;


            &.mod-green {
              background: #3fbd0b;
              box-shadow: 0 1px 5px 0 rgba( darken(#3fbd0b, 20),.5);
            }

            &.mod-orange {
              background: #e28f26;
            }

            &.mod-red {
              background: red;
              box-shadow: 0 1px 5px 0 rgba( darken(red, 20),.5);
            }
          }


      .pricingstatus-notif {
        text-align: left;
        outline: none;
        background: lighten(#E28F26, 35);
        border-radius: 4px;
        padding: 18px 20px;
        margin: 0px;
        margin-top: 10px;

        position: relative;

        &::before {
          transition: opacity 100ms ease-in-out;
          content: '';
          position: absolute;
          z-index: 1;
          top: -0px;
          left: -0px;
          right: -0px;
          bottom: -0px;
          border-radius: 4px;
          background: lighten(#E28F26, 30);
          opacity: 0;
          pointer-events: none;

        }
        &:hover::before {
          //opacity: 1;
        }



        @media (max-width: 670px) {
          margin-top: 5px;
          padding: 15px;
        }
      }

        .pricingstatus-notif-header {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          align-content: center;

          position: relative;
          z-index: 3;
          @media (max-width: 670px) {
            display: block;
          }
        }

          .pricingstatus-notif-header-icon {
            svg {
              width: 28px;
              height: 28px;
              path {
                fill: darken(#E28F26, 32);
              }
            }
            @media (max-width: 670px) {
              svg {
              }
            }
          }

          .pricingstatus-notif-header-title {
            font-size: 14px;
            font-weight: 700;
            line-height: 1.3;
            padding-left: 15px;
            color: darken( #E28F26, 34);
            //color: darken(white,90);
            @media (max-width: 670px) {
              font-size: 13px;
              padding-left: 0;
              padding-top: 10px;
            }
          }



        .pricingstatus-notif-content {
          display: block;
          list-style-type: none;
          margin-top: 15px;

          position: relative;
          z-index: 3;

          li {
            display: block;
            color: darken( #E28F26, 32);
            font-size: 13px;
            font-weight: 400;
            line-height: 1.33;
            //color: darken(white,90);
            margin-top: 10px;
            strong {
              font-weight: 600;
            }
            @media (max-width: 670px) {
              font-size: 12px;
            }
          }
        }

        .pricingstatus-notif-emoji {
          svg {
            position: relative;
            top: -1px;
            width: 18px;
            height: 18px;
          }
        }


</style>





<style lang="scss">
@import "../common/style/_variables.scss";
html.mod-app-theme-dark.mod-app-theme-dark.mod-app-theme-dark {

  .pricingstatus {
    background-color: darken(white,80);
    border-color: darken(white,73);

    &.mod-context-settings {
      background-color: darken(white,70);
      border-color: darken(white,64);
    }
  }

  .pricingstatus-section {
    &::before {
      background: darken(white,70);
    }
  }


  .pricingstatus-title {
    color: rgba(white,.9);
    strong {
      color: rgba(white,1);
    }
  }
  .pricingstatus-subtitle1 {
    color: rgba(white,.7);
  }
  .pricingstatus-subtitle2 {
    color: rgba(white,.7);
  }

}
</style>
